export default "<div class=\"promo-code\">Enter Your Book Code</div>\n";